import type { TermedLevel } from '../../common/termedLevel/types';
import { isManNowProduct, MAN_NOW_PARENT_PRODUCT_ID } from '../../config/manNowProducts';

type ContractDocuments = Pick<TermedLevel, 'productId' | 'tosVersion' | 'dosVersion'>;

export function resolveContractDocuments(contract: ContractDocuments) {
    const tosVersion = contract.tosVersion?.trim() || undefined;
    const dosVersion = contract.dosVersion?.trim() || undefined;
    const usesManNowDocumentFallback = !tosVersion && !dosVersion && isManNowProduct(contract.productId);

    return {
        productId: usesManNowDocumentFallback ? MAN_NOW_PARENT_PRODUCT_ID : contract.productId,
        tosVersion,
        dosVersion,
        canOpenTos: usesManNowDocumentFallback || Boolean(tosVersion),
        canOpenDos: usesManNowDocumentFallback || Boolean(dosVersion),
    };
}
